import React, { useState, useEffect } from "react";
import { Flex, Heading, Container, useToast } from "@chakra-ui/react";

import Layout from "@pages/Layout";
import IncompleteProfile from "./IncompleteProfile";
import SearchResult from "./SearchResult";
import SearchForm from "./SearchForm";

import { Separator, View } from "@components";
import { search_persons } from "@lib/datahandlers/company";
import { loadState, saveState } from "@lib/localStorage";
import { PER_PAGE } from "@lib/constants";
import { generateQuery } from "@lib/functions";
import { t } from "@lang/i18n";

const SearchScreen = () => {
  const initCandidateState = {
    fonctions: [],
    experiences: [],
    contracts: [],
    longitude: "",
    latitude: "",
    department: "",
    region: "",
    city: ""
  };
  const initStateLoadMore = { 
    page: 1, 
    has_more: "", 
    loading_more: "" 
  };
  // const initCandidatesState = loadState("candidates") || [];
  const initCandidatesState = [];

  const [form, setForm] = useState(initCandidateState);
  const [candidates, setCandidates] = useState(initCandidatesState);
  const [isLoaded, setLoaded] = useState(false);
  const [isIncompleteProfile, setIsIncompleteProfile] = useState(false);
  const [loadMore, setLoadMore] = useState(initStateLoadMore);

  const toast = useToast();

  const getQueryParamsValues = (form) => {
    const data = form;

    const new_data = Object.entries(data).map(el => {
        if (Array.isArray(el[1]) && el[1].length > 0) {
          return {
            filter: el[0],
            value: el[1]
          }
        } else if (!Array.isArray(el[1]) && el[1] !== "") {
          return {
            filter: el[0],
            value: el[1]
          }
        } else return;
    });
    return new_data
  };
  const setQueryParamsValues = (queryList) => {
    console.log(queryList)
    queryList.map(el => {
      if (el != null) {
        setForm((prevState) => {
          return { ...prevState, [el.filter]: el.value }
        })
      }
    })
  };

  const onSearch = async (page) => {
    setLoaded(true);
    const SEARCH_PARAMS = ["fonctions", "contracts", "experiences", "latitude", "longitude", "department", "region", "city", "address"];
    const baseUrl = '/persons/search';
    const searchQuery = generateQuery(SEARCH_PARAMS, form, page=1, baseUrl);  
    console.log('search: ', searchQuery)
    
    const result = await search_persons(searchQuery);
    if (result.success) {
      setLoaded(false);
        setLoadMore({
          ...loadMore,
          has_more: result.data.length === PER_PAGE,
        });
        setCandidates(result.data);
        // saveState("candidates", result.data);
        // saveState("params", getQueryParamsValues(form));
        return;
    }
    setLoaded(false);
    toast({ 
      description: "Une erreur s'est produite lors de la recherche de candidats",
      status: "error", position: "bottom-right", variant: "left-accent", isClosable: true 
    }); 
  };

  // check if company's profile is complete / incomplete
  useEffect(() => {
    const data = loadState("user-data");
    if (data) setIsIncompleteProfile(data.completed === 1 ? true : false)
  }, []);

  // useEffect(() => {
  //   const data = loadState("params");
  //   if (data) setQueryParamsValues(loadState("params"));
  // }, []);

  return (
    <Layout isNavBarVisible isFooterVisible menuType="company">
      <Container maxW="1024px" bg="white" minHeight='calc(100vh - 100px)' py="36px" px={["16px","","","100px"]} borderRadius="4px">
        <Flex flexDir="column">
          <Heading as="h1" fontSize="30px" color="black" textAlign="center">
            { t('company.search_candidates.title') }
          </Heading>

          <Separator />

          {/* Complete your account */}
          <View if={!isIncompleteProfile}>
            <IncompleteProfile />
          </View>

          {/* Profile Completed --> Search */}
          <View if={isIncompleteProfile}>
            <SearchForm
              form={form}
              setForm={setForm}
              onSearch={onSearch}
              page={loadMore.page}
            />
            <SearchResult
              form={form}
              isLoaded={isLoaded}
              candidates={candidates}
              setCandidates={setCandidates}
              loadMore={loadMore}
              setLoadMore={setLoadMore}
              generateQuery={generateQuery}
            />
          </View>
        </Flex>
    </Container>
    </Layout>
  );
};

export default SearchScreen;
